/* Mini-carrousel des vignettes de la page collection.
   Feuilleter un produit sans ouvrir sa fiche. Les fleches sont posees par-dessus
   le lien qui couvre l'image : il faut donc arreter la propagation, sinon un
   clic sur une fleche ouvre la fiche. */
(function () {
  if (window.__skydriftMini) return;
  window.__skydriftMini = true;

  document.querySelectorAll("[data-mini]").forEach(cadre => {
    const piste = cadre.querySelector("[data-mini-piste]");
    const vues = piste ? Array.from(piste.children) : [];
    if (vues.length < 2) return;                    // une seule image : pas de fleches

    const compteur = cadre.querySelector("[data-mini-compte]");
    let index = 0;

    const aller = i => {
      index = (i + vues.length) % vues.length;
      piste.style.transform = "translateX(" + index * -100 + "%)";
      if (compteur) compteur.textContent = (index + 1) + " / " + vues.length;
      // on ne charge une image que lorsqu'elle approche
      const proche = vues[(index + 1) % vues.length].querySelector("img");
      if (proche && proche.dataset.src) { proche.src = proche.dataset.src; delete proche.dataset.src; }
    };

    cadre.querySelectorAll("[data-mini-prec], [data-mini-suiv]").forEach(b => {
      b.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();
        aller(index + (b.hasAttribute("data-mini-suiv") ? 1 : -1));
      });
    });

    let depart = null;
    cadre.addEventListener("touchstart", e => { depart = e.touches[0].clientX; }, { passive: true });
    cadre.addEventListener("touchend", e => {
      if (depart === null) return;
      const d = e.changedTouches[0].clientX - depart;
      if (Math.abs(d) > 45) aller(index + (d < 0 ? 1 : -1));
      depart = null;
    }, { passive: true });

    aller(0);
  });
})();
